class RateLimiter {

    maxConcurrentCalls: number;
    tokenCount: number;
    timeout: number;

    constructor(maxConcurrentCalls: number, timeoutSeconds = 15) {
        this.maxConcurrentCalls = maxConcurrentCalls;
        this.tokenCount = maxConcurrentCalls;

        this.timeout = timeoutSeconds * 1000
    }


    async requestToken(): Promise<() => void> {
        return new Promise((resolve, _reject) => {
            const intervalId = setInterval(() => {
                if (this.tokenCount >= 1) {
                    this.tokenCount--;
                    clearInterval(intervalId);

                    const tokenTimeout = setTimeout(() => {
                        this.returnToken();
                    }, this.timeout);

                    resolve(() => {
                        clearTimeout(tokenTimeout);
                        this.returnToken();
                    });


                }
            }, 250)
        });
    }

    private returnToken(): void {
        this.tokenCount = this.tokenCount < this.maxConcurrentCalls ? 
            this.tokenCount + 1 
            : this.tokenCount;

    }
}

export {RateLimiter}